import { InjectionToken } from '@angular/core';

export enum SharedLibProject {
  MbsUi = 'mbs-ui',
  MbsReseller = 'mbs-reseller',
  MbsConnect = 'mbs-connect',
  OnlineAccess = 'online-access',
  AgentLocal = 'agent-local'
}

export const SHARED_LIB_PROJECT_CONFIG = new InjectionToken<SharedLibProject>('SHARED_LIB_PROJECT_CONFIG', {
  providedIn: 'root',
  factory: () => SharedLibProject.MbsUi
});
